module.exports = __webpack_public_path__ + "media/images/JessR-02524831be1890b4eda7ef0b5d6e3671.png";